module.exports = __webpack_public_path__ + "img/allyBioPhoto3.0f3b2c81.jpg";